/*
 * @Author: 赵健
 * @Date: 2021-01-14 10:51:48
 * @LastEditTime: 2021-01-27 16:11:26
 * @LastEditors: 赵健
 * @Description: 修改描述
 * @FilePath: \trunk\src\router\modules\organ.js
 */

import Layout from '@/layout'
import Link from '@/layout/link'
import store from '@/store'
import { sameList } from '@/utils'
const organRouter = {
  path: '/merchant',
  component: Link,
  meta: { title: '商家中心' },
  // redirect: '/merchant/organManage',
  redirect: to => {
    for (let i = 0; i < organRouter.children.length; i++) {
      const { path, meta } = organRouter.children[i]
      if (sameList(store.getters.roles, meta.roles) || meta.roles === undefined) return path
    }
  },
  children: [
    // {
    //   path: '/merchant/test',
    //   component: Link,
    //   alwaysShow: true,
    //   meta: { title: '测试目录', icon: 'menu_zuzhi', noCache: true },
    //   children: [
    //     {
    //       path: '/merchant/test',
    //       component: Layout,
    //       meta: { title: '测试目录1', noCache: true },
    //       children: [
    //         {
    //           path: '',
    //           component: () => import('@/views/manage/organManage/organ'),
    //           name: 'OrganManageOrgan',
    //           meta: { title: '测试组件', noCache: true }
    //         },
    //         {
    //           path: 'add',
    //           component: () => import('@/views/manage/organManage/organ/add'),
    //           name: 'OrganManageOrganAdd',
    //           hidden: true,
    //           meta: { title: '二级页面', noCache: true, activeMenu: '/merchant/test' }
    //         }
    //       ]
    //     }
    //   ]
    // },
    {
      path: '/merchant/merchantManage',
      component: Link,
      alwaysShow: true,
      meta: { title: '商家管理', icon: 'shangjia' },
      children: [
        {
          path: '',
          component: Layout,
          meta: { title: '商家管理', noCache: true },
          children: [
            {
              path: '',
              component: () => import('@/views/merchantCenter/merchantManage/'),
              name: 'MerchantMerchantManage',
              meta: { title: '商家信息', noCache: true }
            },
            {
              path: 'edit',
              component: () => import('@/views/merchantCenter/merchantManage/edit'),
              name: 'MerchantMerchantManageEdit',
              hidden: true,
              meta: { title: '完善资料', noCache: true, activeMenu: '/merchant/merchantManage' }
            }
          ]
        }
      ]
    },
    {
      path: '/merchant/equityManage',
      component: Link,
      alwaysShow: true,
      meta: { title: '权益管理', icon: 'quanyi', noCache: true },
      children: [
        {
          path: '',
          component: Layout,
          meta: { title: '权益管理', noCache: true },
          children: [
            {
              path: '',
              component: () => import('@/views/merchantCenter/equityManage/'),
              name: 'MerchantEquityManage',
              meta: { title: '权益管理', noCache: false }
            },
            {
              path: 'add',
              component: () => import('@/views/merchantCenter/equityManage/add'),
              name: 'MerchantEquityManageAdd',
              hidden: true,
              meta: { title: '新增权益', noCache: true, activeMenu: '/merchant/equityManage' }
            },
            {
              path: 'edit',
              component: () => import('@/views/merchantCenter/equityManage/add'),
              name: 'MerchantEquityManageAdd',
              hidden: true,
              meta: { title: '编辑权益', noCache: true, activeMenu: '/merchant/equityManage' }
            },
            {
              path: 'relevance',
              component: () => import('@/views/merchantCenter/equityManage/relevance'),
              name: 'MerchantEquityManageRelevance',
              hidden: true,
              meta: { title: '关联会员', noCache: true, activeMenu: '/merchant/equityManage' }
            },
            {
              path: 'info',
              component: () => import('@/views/merchantCenter/equityManage/info'),
              name: 'MerchantEquityManageInfo',
              hidden: true,
              meta: { title: '权益详情', noCache: true, activeMenu: '/merchant/equityManage' }
            }
          ]
        }
      ]
    },
    {
      path: '/merchant/orderManage',
      component: Link,
      alwaysShow: true,
      meta: { title: '订单管理', icon: 'dingdan', noCache: true },
      children: [
        {
          path: '',
          component: Layout,
          meta: { title: '订单管理', noCache: true },
          children: [
            {
              path: '',
              component: () => import('@/views/merchantCenter/orderManage/'),
              name: 'MerchantOrderManage',
              meta: { title: '订单管理', noCache: false }
            },
            {
              path: 'info',
              component: () => import('@/views/merchantCenter/orderManage/info'),
              name: 'MerchantOrderManageInfo',
              hidden: true,
              meta: { title: '订单详情', noCache: true, activeMenu: '/merchant/orderManage' }
            },
            {
              path: 'confirm',
              component: () => import('@/views/merchantCenter/orderManage/info'),
              name: 'MerchantOrderManageInfo',
              hidden: true,
              meta: { title: '确认订单', noCache: true, activeMenu: '/merchant/orderManage' }
            },
            {
              path: 'back',
              component: () => import('@/views/merchantCenter/orderManage/info'),
              name: 'MerchantOrderManageInfo',
              hidden: true,
              meta: { title: '退回订单', noCache: true, activeMenu: '/merchant/orderManage' }
            },
            {
              path: 'cancel',
              component: () => import('@/views/merchantCenter/orderManage/info'),
              name: 'MerchantOrderManageInfo',
              hidden: true,
              meta: { title: '核销订单', noCache: true, activeMenu: '/merchant/orderManage' }
            }
          ]
        }
      ]
    }
  ]
}

organRouter.children.forEach((item, index) => {
  item.redirect = to => {
    for (let i = 0; i < organRouter.children[index].children.length; i++) {
      const { path, meta } = organRouter.children[index].children[i]
      if (sameList(store.getters.roles, meta.roles) || meta.roles === undefined) return path
    }
  }
})
export default organRouter
